import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import ConflictModalWrapper from '../../components/modals/conflict_modal/conflict_modal_wrapper';
import { propertyStatuses } from '../../utils/property';

const PropertyStatusCell = ({ value }) => {
  const name = _.get(value, 'type_property_status.name', '');
  const code = _.get(value, 'type_property_status.code', '');
  const hasConflict = code === propertyStatuses.pendingDelete.code;

  return (
    <div className="d-flex align-items-center h-100">
      <div className="property-status-container">
        {hasConflict && (
          <div className="property-status-conflict">
            Conflict
            <ConflictModalWrapper property={value}>
              <span className="icon-help" />
            </ConflictModalWrapper>
          </div>
        )}
        <div
          className={classnames('property-status-name', {
            'property-status-name--with-conflict': hasConflict,
          })}
        >
          {hasConflict ? propertyStatuses.pendingDelete.name : name}
        </div>
      </div>
    </div>
  );
};

PropertyStatusCell.propTypes = {
  value: PropTypes.shape({
    status: PropTypes.shape({
      code: PropTypes.string,
      name: PropTypes.string,
    }),
  }),
};

export default PropertyStatusCell;
